module.exports = __webpack_public_path__ + "img/rule-zh.21e906a5.png";